module.exports = __webpack_public_path__ + "img/ic_discover_generate.c85ab02.svg";